import Queries from "../../queries/queries2";
import React from "react";
import ReportingContainer from "../Reporting/ReportingContainer";
import SalesChart from "./SalesChart";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

class SalesContainer extends ReportingContainer {
  render() {
    return (
      <ReportingContainer
        {...this.props}
        type={"SALES"}
        // header={"ids_sales"}
        header={"ids_reports"}
        query={Queries.getSalesReportData}
        Chart={SalesChart}
        hideBudgetTypeSelect={true}
        hideReportsTypeSelect={false}
      />
    );
  }
}

export default withRouter(injectIntl(SalesContainer));
